import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
// import axios from "../../API/axios";
import axios, { PublicKey } from "../../API/axios";

import { Button, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import ReactSelect from "react-select";
import toast from "react-hot-toast";
import { NavLink, Link } from "react-router-dom";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { ChevronDown } from "react-feather";
import DataTable from "react-data-table-component";
import { Edit2, Trash2 } from "react-feather"; // Icons for Edit and Delete

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

// import defaultImage from "../../../src/assets/images/Default_user_image.png";

function ManageCard() {
  const sessionId = localStorage.getItem("sessionId");
  const userUID = localStorage.getItem("userUID");
  const [display, setDisplay] = useState(false);
  const [search, setSearch] = useState("");
  // console.log("candidateData", candidateData);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  const [showupdate, setShowUpdate] = useState(false);
  const handleShowUpdate = () => setShowUpdate(true);
  const handleUpdateClose = () => {
    setShowUpdate(false);
  };

  const [addClass, setAddClass] = useState("");
  const [classType, setClassType] = useState("");
  const [classTypeName, setClassTypeName] = useState([]);

  const [candidateList, setCandidateList] = useState([]);
  const [candidateData, setCandidateData] = useState([]);

  const [classGroupBatch, setClassGroupBatch] = useState("Class");
  const [groupBatchType, setGroupBatchType] = useState("Class");

  const handleTabChange = (tab) => {
    console.log("tab", tab);

    const type = tab === 2 ? "Batch" : "Class";
    console.log("type", type);
    setGroupBatchType(type);
    setClassGroupBatch(type);
    setClassTypeName(classTypeOptions.find(option => option.value === type));
  };

  const getGetAllCandidate = () => {
    try {
      const requestData = {
        sessionId: sessionId,
        name: search,
        type: groupBatchType,
      };
      console.log("requestData", requestData);

      axios
        .post(`/Institute/GetCandidateClasses`, requestData)
        .then((response) => {
          console.log("response1====>", response.data.responseData);
          const res = response.data.responseData;
          const details = response.data.responseData;
          setCandidateList(res);
          setCandidateData(details);
        });
    } catch (e) {
      console.log("e========>", e);
      if (e.response && e.response.status === 404) {
        setDisplay(true);
      }
    }
  };

  useEffect(() => {
    getGetAllCandidate();
  }, [search, groupBatchType]);

  const AddClass = (page) => {
    setDisplay(true);
    console.log("add class working");

    try {
      const data = {
        sessionId: sessionId,
        name: addClass,
        type: classType,
      };
      console.log("data====>", data);

      axios.post(`/Institute/AddCandidateClass`, data).then((response) => {
        // const res = response.data.responseData.jobsList;
        console.log("AddClass", response);
        toast.success(response.data.message);
        getGetAllCandidate();
        setShow(false);
        setDisplay(false);
        setAddClass("");
        setClassType("");
      });
    } catch (e) {
      console.log("e==========>");

      if (e.response && e.response.status === 404) {
        // setIsError(true);
      }
    }
  };

  function selectClassType(val) {
    setClassType(val.value);
    setClassTypeName(val);
  }

  const classTypeOptions = [
    { value: "Class", label: "Class" },
    { value: "Batch", label: "Batch" },
  ];

  const [activeTab, setActiveTab] = useState(1);

  const tabStyle = (isActive) => ({
    borderBottom: isActive ? "3px solid #feaa00" : "none",
    cursor: "pointer",
    width: "100px",
    height: "50px",
    lineHeight: "50px",
    textAlign: "center",
    // backgroundColor: isActive ? "#f0f0f0" : "#feaa00",
  });



  const columns = [
    {
      name: "GROUP NAME",
      center: true,
      sortable: true,
      minWidth: "150px",
      selector: (row) => row.name,
    },

    {
      name: "Number Of Candidate",
      center: true,
      sortable: true,
      minWidth: "150px",
      selector: (row) => row.status,
    },
    {
      name: "Action",
      center: true,
      sortable: true,
      minWidth: "150px",
      // selector: (row) => row.status,
      cell: (row) => (
        <div>
          <EditIcon className="pointer me-2" onClick={() => { handleShowUpdate(); setclassid(row.id); setCandidateData(row) }} size={8} />

          <DeleteIcon className="pointer text-danger"
            onClick={() => {
              setshowDelete(!showDelete);
              setclassid(row.id)
            }}
            size={8} />
        </div>
      ),


    },

  ];


  //  .........................Update class and batch ......................
  console.log('classGroupBatch', classGroupBatch);

  const UpdateClass = () => {
    setDisplay(true);
    console.log("add class working");

    try {
      const data = {
        sessionId: sessionId,
        name: addClass,
        type: classGroupBatch,
        id: classid,
      };
      console.log("data====>", data);

      axios.post(`/Institute/UpdateCandidateClass`, data).then((response) => {
        console.log("Update Class", response);
        toast.success(response.data.message);
        getGetAllCandidate();
        setShow(false);
        setDisplay(false);
        handleUpdateClose();

      });
    } catch (e) {
      console.log("Update Class");

      if (e.response && e.response.status === 404) {
        // setIsError(true);
      }
    }
  };

  useEffect(() => {
    if (candidateData) {
      setAddClass(candidateData?.name)

    }
  }, [candidateData]);




  //  .........................delete class and batch ......................

  const [classid, setclassid] = useState("");
  const [showDelete, setshowDelete] = useState(false);
  const handleRemoveClose = () => { setshowDelete(false) };

  const handleDelete = async () => {
    setDisplay(true);

    const Data = {
      sessionId: sessionId,
      id: classid,
      type: classGroupBatch,

    };
    console.log("Data22", Data);

    try {
      const response = await axios.post("/Institute/DeleteCandidateClass", Data, {
        headers: {
          PublicKey,
        },
      });
      toast.success(response.data.message);
      getGetAllCandidate();
      setDisplay(false);
      handleRemoveClose();
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response.data.message);
    }
  };



  return (
    <>
      <section className="pricing-section-three container jobapplication bulkResume view-job-style pt-5">
        <div className="mt-2">
          <h4 className="orange-title">
            <span className="orange-box me-2"></span>
            Manage Class{" "}
          </h4>
        </div>
        <div className="container st3">
          <div className="tabButton d-flex w-100 ps-0 connectionTab mt-1">
            {/* <NavLink
              onClick={() => handleTabChange(0)}
              style={tabStyle(classGroupBatch === "All")}
            >
              <p className="f-14 m-0 tabName tab-color">ALL</p>
            </NavLink> */}
            <NavLink
              onClick={() => handleTabChange(1)}
              style={tabStyle(classGroupBatch === "Class")}
            >
              <p className="f-14 m-0 tabName tab-color">Class</p>
            </NavLink>
            <NavLink
              onClick={() => handleTabChange(2)}
              style={tabStyle(classGroupBatch === "Batch")}
            >
              <p className="f-14 m-0 tabName tab-color">Batch</p>
            </NavLink>
          </div>
          <div className="tabContent">
            <div className="manage-search-container">
              <div className="manage-search-bar">
                <SearchIcon className="icon" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="manage-search-input"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <button
                className="add-batch-btn manage-button"
                onClick={handleShow}
              >
                + Add Class
              </button>
            </div>
          </div>

          <div className="manage-batches-container">
            <h2 className="manage-heading">{classGroupBatch} List</h2>
          </div>
          {display ? (
            (console.log("no data found"), (<p>Loading...</p>))
          ) : (
            <div className="scroll-react-dataTable">

              <div className="react-dataTable">
                <DataTable
                  noHeader
                  pagination
                  columns={columns}
                  paginationPerPage={7}
                  className="react-dataTable"
                  sortIcon={<ChevronDown size={10} />}
                  // paginationDefaultPage={currentPage + 1}
                  //   paginationComponent={CustomPagination} 
                  data={candidateList}
                />
              </div>
            </div>
          )}
        </div>
      </section>

      <div className="manage-class-main-container">

        {/* .......add class modal....  */}

        <Modal show={show} onHide={handleClose} centered size="md">
          <Modal.Header>
            <Modal.Title>Add Class</Modal.Title>
            <CloseSharpIcon className="pointer" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body className="settings">
            {/* <div className="upload-icon text-center mb-3"></div> */}
            <Row>
              <Col md={6}>
                <Form.Group controlId="Name_Title">
                  <Form.Label className="class-type">
                    Type
                    <span style={{ color: "red" }} className="ms-2">
                      *
                    </span>
                  </Form.Label>
                </Form.Group>

                <div className="post-form-group">
                  {/* <label htmlFor="about">
                    Job type <span className="text-danger ms-2">*</span>
                  </label> */}

                  <ReactSelect
                    options={classTypeOptions}
                    onChange={selectClassType}

                    value={classTypeName}
                    placeholder="Select Type"
                    // styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                    styles={customStyles}
                  />
                  {/* {display && !jobTypeId ? (
                    <span className="error_msg_lbl">Select Job type </span>
                  ) : null} */}
                </div>
              </Col>

              <Col md={6}>
                <div className="post-form-group">
                  <label htmlFor="about">
                    Name{" "}
                    <span style={{ color: "red" }} className="ms-2">
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    value={addClass}
                    onChange={(e) => setAddClass(e.target.value)}
                    placeholder="Enter class name"
                  />
                  {/* {display && !addClass ? (
              <span className="error_msg_lbl">Enter class name</span>
            ) : null} */}
                </div>
              </Col>
            </Row>
            <div className="add-class-submit-button mt-4 d-flex justify-content-center">
              <Button onClick={AddClass}>Add</Button>
            </div>
          </Modal.Body>
        </Modal>


        {/* .......Update class modal....  */}

        <Modal show={showupdate} onHide={handleUpdateClose} centered size="md">
          <Modal.Header>
            <Modal.Title>Update Class</Modal.Title>
            <CloseSharpIcon className="pointer" onClick={handleUpdateClose} />
          </Modal.Header>
          <Modal.Body className="settings">
            {/* <div className="upload-icon text-center mb-3"></div> */}
            <Row>

              <Col md={12}>
                <div className="post-form-group">
                  <label htmlFor="about">
                    Name{" "}
                    <span style={{ color: "red" }} className="ms-2">
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    value={addClass}
                    onChange={(e) => setAddClass(e.target.value)}
                    placeholder="Enter class name"
                  />
                  {/* {display && !addClass ? (
              <span className="error_msg_lbl">Enter class name</span>
            ) : null} */}
                </div>
              </Col>
            </Row>
            <div className="add-class-submit-button mt-4 d-flex justify-content-center">
              <Button onClick={UpdateClass} style={{ width: "90px" }}>Update</Button>
            </div>
          </Modal.Body>
        </Modal>


        {/* .......delete modal....  */}

        <Modal show={showDelete} onHide={handleRemoveClose} centered>
          <Modal.Header >
            <Modal.Title>Confirm Delete</Modal.Title>
            <CloseSharpIcon className="pointer" onClick={handleRemoveClose} />
          </Modal.Header>
          <Modal.Body className="settings">
            <div className=" mb-3">
              <p>Are you sure you want to delete your group?</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={handleDelete} className="btn btn-danger me-2">
              Confirm Delete
            </button>
            <button onClick={handleRemoveClose} className="btn btn-secondary">
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    </>
  );
}

export default ManageCard;
